module.exports = __webpack_public_path__ + "img/53.041b1860.svg";